((document, window, history) => {
	const pushState = history.pushState;
	const youTubeRegex = RegExp(/(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i);

	// cookie compliance banner
	function cookieCompliance() {
		if (document.querySelector('.site-farlo-ui-biscuit-banner__button')) {
			document.querySelector('.site-farlo-ui-biscuit-banner__button').addEventListener('click', (e) => {
				e.preventDefault();

				e.target.closest('.site-farlo-ui-biscuit-banner').classList.add('site-farlo-ui-biscuit-banner--hide');

				window._farlo.storage.set('cookieCompliance', 'true', 'cookie');
			});
		}

		if (document.querySelector('.site-farlo-ui-biscuit-banner__button--close')) {
			document.querySelector('.site-farlo-ui-biscuit-banner__button--close').addEventListener('click', (e) => {
				e.preventDefault();

				e.target.closest('.site-farlo-ui-biscuit-banner').classList.add('site-farlo-ui-biscuit-banner--hide');
			});
		}
	}


	function wrapFirstWordWithSpan() {
		// Select all elements with the class '.team__grid-item-title'
		var titles = document.querySelectorAll('.team__grid-item-title');
	  
		// Loop through each element
		titles.forEach(function (title) {
		  // Get the text content of the element
		  var text = title.textContent.trim();
	  
		  // Extract the first word
		  var firstWord = text.split(' ')[0];
	  
		  // Check if there is more than one word before wrapping in a span
		  if (text.indexOf(' ') !== -1) {
			// Create a new span element
			var span = document.createElement('span');
	  
			// Set the span's text content to the first word
			span.textContent = firstWord;
	  
			// Wrap the first word with the span
			title.innerHTML = text.replace(firstWord, span.outerHTML);
		  }
		});
	  }

	function formSelect() {
		// Get all input and textarea elements within the form
		var inputFields = document.querySelectorAll('#gform_1 input, #gform_1 textarea');
		var form = document.querySelector('#gform_1');
		
		// Function to add the "item-active" class to the parent .gfield div
		function addActiveClass(event) {
		  var field = event.target;
		  var parentGField = field.closest('.gfield');
		
		  if (parentGField) {
			parentGField.classList.add('item-active');
		  }
		}
		
		// Function to check input/textarea values and update the "item-active" class
		function checkFieldValues() {
		  inputFields.forEach(function (field) {
			var parentGField = field.closest('.gfield');
			
			if (parentGField) {
			  if (field.value.trim() !== '') {
				parentGField.classList.add('item-active');
			  } else {
				parentGField.classList.remove('item-active');
			  }
			}
		  });
		}


		  

	
		
		// Add click and input event listeners to each input/textarea element
		inputFields.forEach(function (field) {
		  field.addEventListener('click', addActiveClass);
		  field.addEventListener('input', checkFieldValues);
		});
		
		// Add a blur event listener to the form to remove the "item-active" class
		form.addEventListener('blur', function (event) {
		  if (event.target.matches('input, textarea')) {
			checkFieldValues();
		  }
		});
		
		// Initial check for field values when the page loads
		checkFieldValues();
		
		
		}

	// default navicon
	function navicon() {
		document.querySelector('.site-navigation__navicon').addEventListener('click', (e) => {
			e.preventDefault();
			e.currentTarget.classList.toggle('site-navigation__navicon--active');
			document.querySelector('.site-navigation').classList.toggle('site-navigation--active');
			document.body.classList.toggle('site-navigation--open');
		});
	}

	// default navigation subnav
	function navigation(submenu) {
		if (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0)) {
			window._farlo.helpers.getSiblings(submenu)[ 0 ].addEventListener('click', (e) => {
				if (!e.target.classList.contains('site-navigation__menu-item--active')) {
					e.preventDefault();

					e.currentTarget.classList.add('site-navigation__menu-item--active');
					submenu.classList.add('site-navigation__sub-menu--active');

					for (let i = 0; i < window._farlo.helpers.getSiblings(e.currentTarget.parentNode).length; i += 1) {
						if (window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 0 ] && window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 0 ].classList.contains('site-navigation__menu-item--active')) {
							window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 0 ].classList.remove('site-navigation__menu-item--active');
						}

						if (window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 1 ] && window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 1 ].classList.contains('site-navigation__sub-menu--active')) {
							window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 1 ].classList.remove('site-navigation__sub-menu--active');
						}
					}
				} else {
					return true;
				}
			});
		} else {
			submenu.parentNode.addEventListener('mouseover', () => {
				if (submenu.parentNode.querySelector('.site-navigation__sub-menu--active')) {
					submenu.parentNode.querySelectorAll('.site-navigation__sub-menu--active').forEach((_sel) => {
						_sel.classList.remove('site-navigation__sub-menu--active');
						_sel.parentNode.classList.remove('site-navigation__menu-item--active');
					});
				}
				submenu.classList.add('site-navigation__sub-menu--active');
				submenu.parentNode.classList.add('site-navigation__menu-item--active');
			});

			submenu.parentNode.addEventListener('mouseout', () => {
				submenu.classList.remove('site-navigation__sub-menu--active');
				submenu.parentNode.classList.remove('site-navigation__menu-item--active');
			});
		}
	}

	function farloUiMcSignup(_sel) {
		let farloUiSignupForm = null;

		if (typeof _sel.target !== 'undefined' && _sel.target !== null) {
			if (_sel.target.dataset.crmButtonFor !== '') {
				farloUiSignupForm = new FarloUiMc(_sel.target.dataset.crmButtonFor);
			}
		} else if (farloUiSignupForm) {
			farloUiSignupForm.toggleForm();
		} else {
			farloUiSignupForm = new FarloUiMc(_sel.id);
		}
	}

	function faqs() {
		const accordions = document.querySelectorAll('.site-faqs__accordion-faq');

		const openAccordion = (accordion) => {
			const answer = accordion.querySelector('.site-faqs__accordion-answer');
			accordion.classList.add('site-faqs__accordion-faq--active');
			answer.style.maxHeight = answer.scrollHeight + 'px';
		};

		const closeAccordion = (accordion) => {
			const answer = accordion.querySelector('.site-faqs__accordion-answer');
			accordion.classList.remove('site-faqs__accordion-faq--active');
			answer.style.maxHeight = null;
		};

		accordions.forEach((accordion) => {
			const question = accordion.querySelector('.site-faqs__accordion-question');
			const answer = accordion.querySelector('.site-faqs__accordion-answer');

			question.onclick = () => {
				if (answer.style.maxHeight) {
					closeAccordion(accordion);
				} else {
					accordions.forEach((acc) => closeAccordion(acc));
					openAccordion(accordion);
				}
			};
		});
	}

	function stagesSlides() {
		const stagesList = document.querySelector('.stages');
		const pageDotsContainer = document.querySelector('.stages__page-dots');
	  
		// Add the items and corresponding page dots
		const items = stagesList.querySelectorAll('.stages__item');
		const pageDots = [];
	  
		items.forEach((item, index) => {
		  const dot = document.createElement('div');
		  dot.classList.add('page-dot');
		  pageDotsContainer.appendChild(dot);
		  pageDots.push(dot);
	  
		  // Add click event to jump to the corresponding item
		  dot.addEventListener('click', () => {
			scrollToItem(index);
		  });
		});
	  
		// Initialize variables for automatic scrolling
		let currentItemIndex = 1; // Start with the first item
		let isAutoScrolling = false;
	  
		// Function to scroll to a specific item
		function scrollToItem(index) {
		  stagesList.scrollTo({
			top: items[index].offsetTop,
			behavior: 'smooth',
		  });
	  
		  currentItemIndex = index;
	  
		  // Update page dots
		  updatePageDots();
		}
	  
		// Function to update page dots based on the current scroll position
		function updatePageDots() {
		  const scrollPosition = stagesList.scrollTop;
		  const itemTops = Array.from(items).map(item => item.offsetTop);
	  
		  for (let i = 0; i < itemTops.length; i++) {
			const dot = pageDots[i];
			const itemTop = itemTops[i];
	  
			if (scrollPosition >= itemTop && scrollPosition < itemTop + stagesList.clientHeight) {
			  dot.classList.add('active');
			} else {
			  dot.classList.remove('active');
			}
		  }
		}
	  
		// Listen for the scroll event and update page dots
		stagesList.addEventListener('scroll', updatePageDots);
	  }
	  

	function lightMenuToggle() {
		var black = document.querySelectorAll(".site-masthead");
	
		for (var i = 0; i < black.length; i++) {
			black[i].classList.add("color-menu");
		}
	
		window.addEventListener("scroll", function() {
			var inColorMenu = false;
			var top_of_screen = window.pageYOffset || document.documentElement.scrollTop;
	
			var colorMenus = document.querySelectorAll('.color-menu');
			for (var i = 0; i < colorMenus.length; i++) {
				var top_of_element = colorMenus[i].offsetTop;
				var bottom_of_element = top_of_element + colorMenus[i].offsetHeight;
	
				if (top_of_screen > top_of_element && top_of_screen < bottom_of_element) {
					inColorMenu = true;
					break;
				}
			}
	
			var header = document.querySelector(".site-header");
			if (inColorMenu || top_of_screen === 0) {
				header.classList.add("transparent-menu");
			} else {
				header.classList.remove("transparent-menu");
			}
		});
	}

	function headingLineSpan() {
		    // Get all elements with the class .is-style-heading-3-line
			var elements = document.querySelectorAll('.is-style-heading-3-line');

			// Loop through each element
			elements.forEach(function (element) {
				// Create a new span element
				var spanElement = document.createElement('span');
		
				// Move the content of the original element to the new span element
				while (element.firstChild) {
					spanElement.appendChild(element.firstChild);
				}
		
				// Append the new span element to the original element
				element.appendChild(spanElement);
			});
	}

	function buttonSpan() {
		// Get all elements with the class .is-style-heading-3-line
		var elements = document.querySelectorAll('.wp-block-button__link');

		// Loop through each element
		elements.forEach(function (element) {
			// Create a new span element
			var spanElement = document.createElement('span');
	
			// Move the content of the original element to the new span element
			while (element.firstChild) {
				spanElement.appendChild(element.firstChild);
			}
	
			// Append the new span element to the original element
			element.appendChild(spanElement);
		});
}


	

		// lazyloading
		function lazyloadElements() {
			const observer = new IntersectionObserver(function(entries, obs) {
				entries.forEach(function(entry) {
					// If the entry is not in the viewport, do nothing
					if (!entry.isIntersecting) {
						return;
					}
	
					// Stop observing
					obs.unobserve(entry.target);
	
					// Add class
					entry.target.classList.add('in-view');
				});
			});
	
			// The element to observe
			const elements = document.querySelectorAll('.site-page section, .site-page div, .testimonial__grid-item, .is-style-heading-3-line, .team__grid-item, .case-studies__grid-item, .projects__grid-item, .wp-block-gallery > .wp-block-image, .careers__grid-item');
	
			for (let i = 0; i < elements.length; i += 1) {
				// Attach it to the observer
				observer.observe(elements[ i ]);
			}
		}

		function setWrapperWidthAsCssVariable() {
			const siteWrapper = document.querySelector('.site__wrapper');
		  
			if (siteWrapper) {
			  function updateWrapperWidth() {
				const wrapperWidth = siteWrapper.offsetWidth -140;
				document.documentElement.style.setProperty('--site-wrapper-width', `${wrapperWidth}px`);
			  }
		  
			  // Initial update
			  updateWrapperWidth();
		  
			  // Update on window resize
			  window.addEventListener('resize', updateWrapperWidth);
			} else {
			  console.error('Element with class .site__wrapper not found.');
			} 
		  }
		  
		  // Call the function to set the CSS variable and update on resize
		  setWrapperWidthAsCssVariable();

	function farloUiLightbox(elem, div) {


		if ((elem.nextElementSibling && elem.nextElementSibling.value) || (elem.querySelector('.site-farlo-ui-lightbox__html') && elem.querySelector('.site-farlo-ui-lightbox__html').value)) {
			elem.addEventListener('click', function(e) {
				e.preventDefault();
				e.stopPropagation();
				document.body.classList.add('body--farlo-ui-lightbox-open');
				div.querySelector('.site-farlo-ui-lightbox__inner-content').classList.add('dynamic');

				if ((e.currentTarget.nextElementSibling && e.currentTarget.nextElementSibling.value)) {
					div.querySelector('.site-farlo-ui-lightbox__inner-content').innerHTML = e.currentTarget.nextElementSibling.value;
				} else if (e.currentTarget.querySelector('.site-farlo-ui-lightbox__html') && e.currentTarget.querySelector('.site-farlo-ui-lightbox__html').value) {
					div.querySelector('.site-farlo-ui-lightbox__inner-content').innerHTML = e.currentTarget.querySelector('.site-farlo-ui-lightbox__html').value;
				}
				div.classList.add('site-farlo-ui-lightbox--active');
			});
		}

		if (elem.querySelector('a[href*="youtu.be"]')) {
			elem.querySelector('a[href*="youtu.be"]').addEventListener('click', function(e) {
				e.preventDefault();
				document.body.classList.add('body--farlo-ui-lightbox-open');
				div.querySelector('.site-farlo-ui-lightbox__inner-content').innerHTML = '<iframe class="farlo-ui-lightbox__inner-content-iframe" src="https://www.youtube-nocookie.com/embed/' + e.target.href.match(youTubeRegex)[ 1 ] + '" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
				div.classList.add('site-farlo-ui-lightbox--active');
			});
		}

		if (div.querySelector('.site-farlo-ui-lightbox__button-close')) {
			div.querySelector('.site-farlo-ui-lightbox__button-close').addEventListener('click', function(e) {
				e.preventDefault();
				document.body.classList.remove('body--farlo-ui-lightbox-open');
				e.currentTarget.closest('.site-farlo-ui-lightbox').classList.remove('site-farlo-ui-lightbox--active');
				if (div.querySelector('.site-farlo-ui-lightbox__inner-content.dynamic')) {
					div.querySelector('.site-farlo-ui-lightbox__inner-content').classList.remove('dynamic');
				}
				div.querySelector('.site-farlo-ui-lightbox__inner-content').innerHTML = '';

				if (elem.classList.contains('site-geo-targeting')) {
					window._farlo.storage.set('geotargeted', 'true', 'cookie');
				}
			});
		}
	}

	function stagesScroll(){
		// Get the .stages block
		var stagesBlock = document.querySelector('.stages');
	
		// Listen for scroll events on the window
		window.addEventListener('scroll', function(event) {
			// Get the bounding box of the .stages block
			var stagesBoundingBox = stagesBlock.getBoundingClientRect();
	
			// Check if the current scroll position is outside the .stages block
			if (window.scrollY < stagesBoundingBox.top || window.scrollY > stagesBoundingBox.bottom) {
				// Prevent the default scroll behavior
				event.preventDefault();
			}
		});
	}


	function setWindowHeightVariable() {

			var siteHeader = document.querySelector('.site-header');
		

			var fixedScroll = document.querySelector('.fixed-scroll');
		

	  
		// Function to update the CSS variable
		function updateWindowHeightVariable() {
		  const siteHeaderHeight = siteHeader.offsetHeight;
		  const fixedScrollHeight = fixedScroll.offsetHeight;
		  const totalHeight = fixedScrollHeight + 30;
		  document.documentElement.style.setProperty('--fs-window-height', `${totalHeight}px`);
		}
	  
		// Initial call to set the CSS variable
		updateWindowHeightVariable();
	  
		// Event listener for window resize
		window.addEventListener('resize', updateWindowHeightVariable);
	  }
	  if(document.querySelector('.case-studies__slider')) {
	  // Call the function to set the CSS variable and add the resize event listener
	  setWindowHeightVariable();
	  }


	function smoothScroll(_sel) {
		_sel.addEventListener('click', function(e) {
			e.preventDefault();

			if (document.querySelector('.site-navigation__navicon--active') && document.body.classList.contains('site-navigation--open')) {
				document.querySelector('.site-navigation__navicon').click();
			}

			if (e.target.parentNode.parentNode) {
				e.target.parentNode.parentNode.classList.remove('site-navigation__sub-menu--active');
			}

			if (e.target.parentNode.parentNode.parentNode) {
				e.target.parentNode.parentNode.parentNode.querySelector('a').classList.remove('site-navigation__menu-item--active');
			}

			if (e.target.href.includes('#') && document.getElementById(e.target.href.split('#')[ 1 ])) {
				document.getElementById(e.target.href.split('#')[ 1 ]).scrollIntoView({ behavior: 'smooth' });
			} else {
				window.location.href = e.target.href;
			}
		});
	}

	history.pushState = function(state) {
		if (typeof history.onpushstate === 'function') {
			history.onpushstate({ state });
		}
		return pushState.apply(history, arguments);
	};

	document.addEventListener('DOMContentLoaded', () => {
		const lightboxEmbed = document.querySelectorAll('.site-video-embed-group, .site-farlo-ui-lightbox__toggle');
		let div;
		let divInner;
		let divInnerContent;
		let divClose;

		if (document.querySelector('.site-navigation__navicon')) {
			navicon();
		}

		if (document.querySelector('.site-navigation__sub-menu')) {
			document.querySelectorAll('.site-navigation__sub-menu').forEach((_sel) => {
				navigation(_sel);
			});
		}

		if (document.querySelector('.site-farlo-ui-biscuit-banner')) {
			cookieCompliance();
		}

		if (lightboxEmbed.length > 0) {
			div = document.createElement('div');
			divInner = document.createElement('div');
			divInnerContent = document.createElement('div');
			divClose = document.createElement('button');
			div.className = 'site-farlo-ui-lightbox';
			divInner.className = 'site-farlo-ui-lightbox__inner';
			divInnerContent.className = 'site-farlo-ui-lightbox__inner-content';
			divClose.className = 'site-farlo-ui-lightbox__button-close';

			document.body.appendChild(div);
			document.querySelector('.site-farlo-ui-lightbox').appendChild(divInner);
			document.querySelector('.site-farlo-ui-lightbox__inner').appendChild(divInnerContent);
			document.querySelector('.site-farlo-ui-lightbox__inner').appendChild(divClose);

			lightboxEmbed.forEach(function(elem) {
				farloUiLightbox(elem, div);
			});
		}

		document.querySelectorAll('a[href*="#"]').forEach((_sel) => {
			smoothScroll(_sel);
		});

		if (document.querySelector('.site-faqs')) {
			faqs();
		}

		if (document.querySelector('.stages')){
			stagesSlides();
		}

		if (document.querySelector('.site-page')) {
			lazyloadElements();
		}

		if (document.querySelector('.is-style-heading-3-line')){
			headingLineSpan();
		}

		if (document.querySelector('.wp-block-button__link')){
			buttonSpan();
		}

		if (document.querySelector('.site-farlo-ui-crm')) {
			document.querySelectorAll('[farlo-ui="crm"]').forEach((_sel) => {
				farloUiMcSignup(_sel);
			});
		}

		if (document.querySelector('.site-masthead')) {
			lightMenuToggle();
		}

		if (document.querySelector('.stages')){
			stagesScroll();
		}

		if (document.querySelector('.gfield')) {
			formSelect();
			}

			if(document.querySelector('.team__grid-item-title')){
				wrapFirstWordWithSpan();

			}

		if (document.querySelector('.site-farlo-ui-crm__toggle')) {
			document.querySelectorAll('.site-farlo-ui-crm__toggle').forEach((_sel) => {
				_sel.addEventListener('click', (e) => {
					e.preventDefault();
					e.stopImmediatePropagation();
					farloUiMcSignup(e);
				});
			});
		}

		if (document.querySelector('.site-farlo-ui-ticket-calendar')) {
			document.querySelectorAll('[farlo-ui="calendar"]').forEach((_sel) => {
				_sel.farloUiTicketCalendar(_sel);
			});
		}
	});

	window.addEventListener('load', () => {
		if (document.querySelector('.site-farlo-ui-revolver-carousel')) {
			document.querySelectorAll('[farlo-ui="carousel"]').forEach((_sel) => {
				_sel.farloUiRevolverCarousel();
			});
		}

		if (document.querySelector('.site-farlo-ui-lightbox')) {
			document.querySelectorAll('[farlo-ui="lightbox"]').forEach((_sel) => {
				_sel.farloUiLightbox();
			});
		}
	});

	if (typeof navigator !== 'undefined') {
		navigator.serviceWorker.getRegistrations().then(function(registrations) {
			for (const registration of registrations) {
				registration.unregister();
			}
		});
	}

	  	// Tolerance (px) is the size a viewport can chance
	// before updating css variables this prevents jerky
	// resizing when browser chrome disappears on mobile
	const tolerance = 60;

	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${ vh }px`);
	let lastHeight = window.innerHeight;

	let vw = window.innerWidth * 0.01;
	document.documentElement.style.setProperty('--vw', `${ vw }px`);
	let lastWidth = window.innerWidth;

	let headerHeight = document.querySelector('.site-header');
	if(headerHeight){
		var offsetHeight = headerHeight.offsetHeight;
	} else {
		var offsetHeight = 100;
	}
	document.documentElement.style.setProperty('--header-height', `${ offsetHeight }px`);

	const resizeVars = () => {
		if (Math.abs(lastHeight - window.innerHeight) > tolerance) {
			vh = window.innerHeight * 0.01;
			document.documentElement.style.setProperty('--vh', `${ vh }px`);
			lastHeight = window.innerHeight;
		}

		if (lastWidth !== window.innerWidth) {
			vw = window.innerWidth * 0.01;
			document.documentElement.style.setProperty('--vw', `${ vw }px`);
			lastWidth = window.innerWidth;
		}
	};
	window.addEventListener('resize', () => {
		resizeVars();
	});
	setTimeout(function() {
		resizeVars();
	}, 100);



	  
	
})(document, window, history);
